import { Trans } from '@lingui/react'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import * as styles from './footer-copyright.styles'

export const FooterCopyright = () => (
  <Typography
    align="center"
    color="textSecondary"
    css={styles.text}
    variant="b4"
  >
    <Trans id="flow.copyright" values={{ year: new Date().getFullYear() }} />
  </Typography>
)
